import React from "react";
import { styled } from "@linaria/react";
import { color, fonts } from "@ui";

const Wrapper = styled.div`
  font: ${fonts.body2};
  font-weight: normal;
`;

const LegendTooltipHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
`;

const SerieName = styled.div`
  color: ${color.carbon900};
  font: ${fonts.body2SemiBold};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Divider = styled.div`
  border-top: 1px solid ${color.titanium200};
  margin-bottom: 8px;
  margin-top: 12px;
`;

interface P extends React.HtmlHTMLAttributes<HTMLDivElement> {
  serieName: string;
  symbol: React.ReactNode;
}

function LegendTooltip({ children, serieName, symbol, ...props }: P) {
  return (
    <Wrapper
      {...props}
      onClick={e => {
        e.stopPropagation();
      }}
    >
      <LegendTooltipHeader>
        <SerieName>{serieName}</SerieName>
        {symbol}
      </LegendTooltipHeader>
      {children}
    </Wrapper>
  );
}

export default LegendTooltip;
